import {createAction, PayloadAction} from '@reduxjs/toolkit';
import {put, call, fork, takeLatest, ForkEffect} from 'redux-saga/effects';

import {
  fetchLightProjects,
  fetchMapProjects,
  fetchBestFeasibilities,
} from 'App/features/searchEntities/lightProjects/lightProjectsApi';
import {
  requesting,
  fail,
  loadLightProjects,
  loadMapProjects,
  loadBestFeasibilities,
} from 'App/features/searchEntities/lightProjects/lightProjectsSlice';
import {
  TLightProjects,
  TMapProjects,
  TBestFeasibilities,
} from 'App/features/searchEntities/lightProjects/lightProjectsTypes';

import * as log from '../../../../../logger';

type RequestLightProjectsPayload = {
  queryParameters: Record<string, string>;
  withBestFeasibilities?: boolean;
};

export const requestLoadLightProjects = createAction(
  'lightProjects/requestLoadLightProjects',
);

function* loadLightProjectsSaga({
  queryParameters,
}: RequestLightProjectsPayload) {
  yield put(requesting());

  const lightProjects: TLightProjects = yield call(
    fetchLightProjects,
    queryParameters,
  );

  yield put(loadLightProjects({lightProjects}));
}

function* loadMapProjectsSaga({queryParameters}: RequestLightProjectsPayload) {
  const mapProjects: TMapProjects = yield call(
    fetchMapProjects,
    queryParameters,
  );

  yield put(loadMapProjects({mapProjects}));
}

function* loadBestFeasibilitiesSaga({
  queryParameters,
}: RequestLightProjectsPayload) {
  const bestFeasibilities: TBestFeasibilities = yield call(
    fetchBestFeasibilities,
    queryParameters,
  );

  yield put(loadBestFeasibilities({bestFeasibilities}));
}

function* fetchAll(payload: RequestLightProjectsPayload) {
  yield fork(loadLightProjectsSaga, payload);
  yield fork(loadMapProjectsSaga, payload);
  if (payload.withBestFeasibilities) {
    yield fork(loadBestFeasibilitiesSaga, payload);
  }
}

function* requestLoadLightProjectsSaga({
  payload,
}: PayloadAction<RequestLightProjectsPayload>) {
  try {
    yield call(fetchAll, payload);
  } catch (error) {
    if (error instanceof Error) {
      yield call(log.exception, error);
    }
    yield put(fail({error: 'requestLoadLightProjectsError'}));
  }
}

function* watchRequestLoadLightProjects(): Generator<
  ForkEffect<void>,
  void,
  unknown
> {
  yield takeLatest(requestLoadLightProjects.type, requestLoadLightProjectsSaga);
}

export default watchRequestLoadLightProjects;
